import React from 'react';

export function ExerciseType(props) {
    return (
        <h4 className="heading-color margin-0"><b>{props.title}</b></h4>
    )


}